import { t } from 'i18next'
import { z } from 'zod'

import { HolidayLevel } from './HolidayLevel'
import { HolidayType } from './HolidayType'

export const Holiday = z.object({
  id: z.string(),
  date: z
    .string()
    .min(1, { message: t('general.form.required') })
    .max(10, { message: t('general.form.maxCaracters', { max: '10' }) }),
  name: z
    .string()
    .min(1, { message: t('general.form.required') })
    .max(255, { message: t('general.form.maxCaracters', { max: '255' }) }),
  type: HolidayType,
  level: HolidayLevel.nullable()
})
export type Holiday = z.infer<typeof Holiday>

export const HolidayList = z.array(Holiday)
export type HolidayList = z.infer<typeof HolidayList>
